<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Admission Overview</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Admission Overview</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="adn-overview ptb--100 ">
  <div class="container">
    <div class="row row-cols-lg-2 row-cols-1">
      <div class="col">
        <div class="text-center"><img alt="Upcoming event" class="img-fluid"
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/upcoming-events/admission-shedule.jpg"></div>
      </div>
      <div class="col">
        <p>As a Raisonian you will initiate your path of learning, imbibe knowledge and inculcate skill sets at our
          institutes. You will start with a journey embellished with state-of-the-art tools, guidance of the finest
          faculty and infrastructure which is promising. An environment which lets you grow, seek questions and ingest
          insightful answers. You will be introduced to the real world through industry tie ups. You will be conveyed
          the norms of the competition outside with the regularly updated curriculum. You will be presented to
          versatility in activities assuring an all round development with us.</p>
        <p>Our institutes are have a vision that would aid you in carving a niche in your success ventures. They are an
          embodiment of education thatinvolves value based education, state-of-the-art infrastructure, and a plethora of
          amenities. They are the reflection of knowledge that ensures you become independent, strong and capable. They
          are the key to the first step of a journey of milestones. After all, it is a system which has been designed by
          the most acclaimed academicians and the masters from all walks of life.</p>
        <ul class="list-before">
          <li>We have more than 25,000+ students studying in our schools, colleges and universities sprawling central
            India - in the cities of Nagpur, Pune, Ahmednagar, Chhindwara, Jalgaon, Amravati and Raipur.</li>
          <li>We have more than 45,000 alumni, which belong to the RGI family. Our alumni work in some of the top notch
            companies, institutes and organization in India and outside. Our students are still a part of our
            family.Once a Raisonian, always a Raisonian!</li>
          <li>We have 2 universities which boast of the excellence we are a part of.</li>
        </ul>
        <p>You are never alone in any endeavor when you study in our institute. We have students who continue to come
          back to us to thank us, applaud us or ask for guidance. It is the trust they have in their faculty and
          educators which paves the way for them. You will receive strength and guidance throughout your journey with
          us.</p>
        <blockquote class="blockquote-div mt-3">
          <p>So, come join the journey where success is not a part of life, success is being a Raisonian!</p>
        </blockquote>
      </div>
    </div>
  </div>
</section>
